// The three sentiment colours the comment widgets share. Several older files
// still carry their own copy of these hex values; new code imports this one.
export const SENTIMENT_COLORS = {
  negative: '#FF6833',
  neutral: '#C7CED1',
  positive: '#8080FF',
} as const

export type SentimentKey = keyof typeof SENTIMENT_COLORS
